import styled from 'styled-components'
import { rgba } from 'polished'

const borderRadius = '1px'

const HitArea = styled.div.attrs(props => ({
  style: {
    width: props.width,
    height: props.height,
    top: props.top || 'initial',
    right: props.right || 'initial',
    bottom: props.bottom || 'initial',
    left: props.left || 'initial',
  },
}))`
  position: absolute;
  border-radius: ${borderRadius};
  background-color: ${({ theme }) => rgba(theme.colors.primary, 0.15)};
  display: block;
  opacity: ${props => (props.isActive ? '1' : '0')};
  transition: opacity ${({ theme }) => theme.transitions.duration[2]};
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
  pointer-events: all;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: ${borderRadius};
  }
`

export default HitArea
